import { render, staticRenderFns } from "./Aktivasi.vue?vue&type=template&id=11e7c952&scoped=true"
import script from "./Aktivasi.vue?vue&type=script&lang=js"
export * from "./Aktivasi.vue?vue&type=script&lang=js"
import style0 from "./Aktivasi.vue?vue&type=style&index=0&id=11e7c952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.26_css-loader@6.11.0_webpack@5.104.1__lodash@4_ca1684712bc6b92d0f967ca402105836/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e7c952",
  null
  
)

export default component.exports